package modysy.datastructures

/** A utility class for a two dimensional vector of doubles.
  *
  * Supports vector arithmetic and implicit conversions from Int, Double, (Int, Int) and (Double, Double).
  * */
// TODO a case class with vars, is this good?
case class Vector2(var x: Double, var y: Double) {

  /** Compute the L2 norm. */
  def norm: Double = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))

  /** Compute the square of the L2 norm (a scalar product with self). */
  def squaredNorm: Double = this.dot(this)

  /** Compute the scalar product with another vector. */
  def dot(other: Vector2): Double = x * other.x + y * other.y

  def +(other: Vector2): Vector2 = Vector2(x + other.x, y + other.y)

  def -(other: Vector2): Vector2 = this + -other

  def unary_- : Vector2 = this * -1

  /** Compute the element-wise multiplication with another vector. */
  def *(other: Vector2): Vector2 = Vector2(x * other.x, y * other.y)

  /** Compute the element-wise division with another vector. */
  def /(other: Vector2): Vector2 = Vector2(x / other.x, y / other.y)

  /** Compute the directional vector (the vector normalized so that the L2 norm is 1). */
  def unit: Vector2 = this / norm

  // TODO this could be better
  /** Checks whether the vector is close to another vector with a given relative tolerance.
    *
    * @return true if the norm of the difference of vectors divided by the sum of their norms is smaller than
    *         relativeTolerance.
    */
  def closeTo(other: Vector2, relativeTolerance: Double = 1e-4): Boolean = {
    val divisor =
      if (Math.abs(norm + other.norm) > relativeTolerance) norm + other.norm
      else 1

    (this - other).norm / divisor < relativeTolerance
  }

  /** Checks whether X and Y coordinates of the vector are smaller or equal to the X and Y coordinates of another vector.
    */
  def atMost(other: Vector2): Boolean = this.x <= other.x && this.y <= other.y
}

object Vector2 {
  // TODO could be better: is there a way to have this for all number types with one function?
  implicit def numericToVector2(d: Double): Vector2 = Vector2(d, d)

  implicit def intToVector2(i: Int): Vector2 = Vector2(i, i)

  implicit def doublePairToVector(pair: (Double, Double)): Vector2 =
    Vector2(pair._1, pair._2)

  implicit def intPairToVector(pair: (Int, Int)): Vector2 =
    Vector2(pair._1, pair._2)

  /** Create a vector from polar coordinates. */
  def fromPolar(distance: Double, angle: Double): Vector2 =
    Vector2(distance * math.cos(angle), distance * math.sin(angle))
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/datastructures/Vector2.scala